/**
 * Component for managing toast notifications.
 */
import * as React from "react"

import Layer from "../Layer"
import ToastContext from "./ToastContext"
import ToastContainer from "./ToastContainer"
import useTheme from "../useTheme"

const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const initMap = new Map<string, JSX.Element>()
  const [toastMap, setToastMap] = React.useState(initMap)
  const {
    spacing: { sm: padding }
  } = useTheme()

  return (
    <ToastContext.Provider value={{ setToastMap }}>
      {children}
      <Layer>
        <ToastContainer toastMap={toastMap} padding={padding} />
      </Layer>
    </ToastContext.Provider>
  )
}

export default ToastProvider
